module.exports = __webpack_public_path__ + "static/media/ils-question.1880335e.svg";